/**
 * Client-side persistent sign-in lockout. UX guard only: the API owns real rate limiting
 * and the lockout reappears after reload because the deadline lives in storage.
 */
export class SignInLockout {
    storage;
    key;
    durationMs;
    now;
    memoryUntil = 0;
    constructor(opts = {}) {
        this.storage = opts.storage ?? null;
        this.key = opts.key ?? "lumora.signin.lockoutUntil";
        this.durationMs = opts.durationMs ?? 15 * 60 * 1000;
        this.now = opts.now ?? Date.now;
    }
    /** Epoch ms when the lock ends; 0 when not locked. Expired deadlines are cleared. */
    get until() {
        const stored = this.storage?.getItem(this.key);
        const parsed = stored ? Number.parseInt(stored, 10) : 0;
        const until = Math.max(this.memoryUntil, Number.isFinite(parsed) ? parsed : 0);
        if (until > 0 && until <= this.now()) {
            this.clear();
            return 0;
        }
        return until;
    }
    isLocked() {
        return this.until > 0;
    }
    remainingSeconds() {
        const until = this.until;
        return until > 0 ? Math.ceil((until - this.now()) / 1000) : 0;
    }
    trigger() {
        const until = this.now() + this.durationMs;
        this.memoryUntil = until;
        this.storage?.setItem(this.key, String(until));
        return until;
    }
    clear() {
        this.memoryUntil = 0;
        this.storage?.removeItem(this.key);
    }
}
//# sourceMappingURL=SignInLockout.js.map